import { Button, useModalRequestClose, type ButtonSize } from '@safetyhub/ui';

/**
 * base `Modal`(`@safetyhub/ui`) footer의 「취소」 — 닫기를 base의 닫기 요청([[useModalRequestClose]])으로
 * 수렴시켜 `isDirty` 확인을 우회하지 않는다(취소가 `onClose`를 직접 부르면 Esc·오버레이·✕만 확인을
 * 거치고 이 버튼은 입력을 그대로 버린다).
 *
 * footer는 base의 context Provider **안**에서 렌더되므로, 이 컴포넌트를 `footer`에 넣으면 잡힌다.
 * Modal 밖에서 쓰이면 context가 없어 `onCancel`로 떨어진다.
 *
 * 사용 예:
 *   <Modal isDirty={dirty} footer={<><ModalCancelButton onCancel={onClose} disabled={busy} />…</>}>
 */
export function ModalCancelButton({
  onCancel,
  disabled = false,
  label = '취소',
  size,
}: {
  onCancel: () => void;
  disabled?: boolean;
  label?: string;
  size?: ButtonSize;
}) {
  const requestClose = useModalRequestClose();
  return (
    <Button variant="secondary" size={size} onClick={requestClose ?? onCancel} disabled={disabled}>
      {label}
    </Button>
  );
}
